import { motion } from "framer-motion";
import GlitchText from "./GlitchText";
import { CITY_TOWER } from "./assets";
import { useLang } from "./LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export const Lore = () => {
  const { t } = useLang();
  const paras = t("world.paragraphs");
  return (
    <section id="world" data-testid="lore-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 kumiko opacity-25" />
      <div className="absolute bottom-0 left-0 right-0 h-32 seigaiha opacity-30 pointer-events-none" />
      <span aria-hidden="true" className="pointer-events-none select-none absolute left-4 top-1/2 -translate-y-1/2 hidden xl:block font-display text-[16rem] leading-none text-white/[0.03]">島</span>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease }}
          className="lg:col-span-7 order-2 lg:order-1"
        >
          <p className="text-[#F9D423] text-xs font-bold tracking-[0.3em] mb-5">{t("world.overline")}</p>
          <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-tight mb-8">
            {t("world.headingLine1")} <br /> {t("world.headingPre")}{" "}
            <GlitchText className="glitch-title text-[#00F2FE]">{t("world.headingGlitch")}</GlitchText>
          </h2>

          <div className="glass rounded-sm p-6 md:p-8 font-mono-x text-sm md:text-base text-slate-300 leading-relaxed space-y-4">
            {paras.map((p, i) => (
              <p key={i} className={i === paras.length - 1 ? "text-[#F9D423]" : ""}>
                <span className="text-[#00F2FE]">&gt;</span> {p}
                {i === paras.length - 1 && <span className="animate-pulse">_</span>}
              </p>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease }}
          className="lg:col-span-5 order-1 lg:order-2"
        >
          <div className="relative aspect-[4/5] rounded-sm border border-[#00F2FE]/30 overflow-hidden shadow-[0_0_50px_rgba(0,242,254,0.18)]">
            <img src={CITY_TOWER} alt="The central spire" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060A14] via-transparent to-transparent" />
            <p className="absolute bottom-5 left-5 font-mono-x text-xs tracking-[0.25em] text-[#00F2FE]">{t("world.caption")}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Lore;
